import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { locale } from '@tcc/i18n';
import { getMessage } from 'util/locale';
import ImageWithLoader from 'common/ImageWithLoader';
import { formatDateToLocale } from 'util/formatters/dateFormatter';
import { Spinner } from '@tcc/crate';

const OverlaySelectLayerDates = ({
  areCompleteMapLayersLoaded,
  completeMapLayers,
  datesAndImages,
  extendedHeight,
  isfilteredByCompleteMapLayers = false,
  onSelect,
  selectedUuid
}) => {
  const somethingHasPreviewImage = !!datesAndImages.find( (entry) => entry.previewUrl );
  const classString = classNames({
    'form-control': true,
    'vra-layer-selector__select': true,
    'vra-layer-selector__select--dates': true,
    'vra-layer-selector__select--with-preview': somethingHasPreviewImage,
    'vra-layer-selector__select--extended': extendedHeight
  });
  const layerList = [];

  datesAndImages.forEach( (layer) => {
    
    if(isfilteredByCompleteMapLayers && !completeMapLayers.hasOwnProperty(layer.overlayUuid)) {
      return;
    }

    const layerClassString = classNames({
      'vra-layer-selector__option': true,
      'vra-layer-selector__option--dates': true,
      'vra-layer-selector__option--selected': selectedUuid === layer.overlayUuid,
      'vra-layer-selector__option--with-preview': !!layer.previewUrl
    });

    let layerImage;
    let imageTitle;
    if( layer.previewUrl ) {
      layerImage = (
        <ImageWithLoader
          imageClass='vra-layer-selector__option-thumbnail'
          src={layer.url}
        />
      );
    }

    let depthTitle;
    if(layer.displayDepth) {
      const depthLabel = getMessage(`label-text__overlay-legend-depth--${layer.layer}`);
      depthTitle = (
        <small className="vra-layer-selector__option__data-subhead">
          ({layer.displayDepth}{depthLabel})
        </small>
      );
    }
    imageTitle = (
      <section className="vra-layer-selector__option-title">
        <header>{layer.name || formatDateToLocale(layer.date, locale)}</header>
        <small className="vra-layer-selector__option__data-subhead--vendor">{layer.vendor}</small>
        {depthTitle}
      </section>
    );

    layerList.push(
      <div
        data-test-id=""
        className={layerClassString}
        key={layer.overlayUuid}
        onClick={ () => onSelect(layer.overlayUuid) }
      >
        {layerImage}
        {imageTitle}
      </div>
    );
  });
  
  return (
    <div className={classString} data-test-id="map-date-selector">
      { !isfilteredByCompleteMapLayers || areCompleteMapLayersLoaded
        ? layerList 
        : <Spinner 
          className={'vra-management-zones-container-spinner left-45'} 
          size='24' 
        />
      }
    </div>
  );
};

OverlaySelectLayerDates.propTypes = {
  areCompleteMapLayersLoaded: PropTypes.bool.isRequired,
  completeMapLayers: PropTypes.object,
  datesAndImages: PropTypes.array.isRequired,
  extendedHeight: PropTypes.bool,
  isfilteredByCompleteMapLayers: PropTypes.bool,
  onSelect: PropTypes.func.isRequired,
  selectedUuid: PropTypes.string
};
export default OverlaySelectLayerDates;
